export enum LayoutType {
  Grid = "grid",
  Vertical = "vertical",
  Horizontal = "horizontal",
  Absolute = "absolute",
}
